export default{
	name : 'notice_dialog',
	props:{
		show : Boolean
	},
	data () {
		return {
			title: '温馨提示',
		}
	},
	methods : {
		close() {
			this.$emit('close');
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/notice_dialog/notice_dialog.controller.js